export let dataProps = {
    id: 0,
    store_id: null,
    salutation_id: null,
    full_name: '', 
    email_address: '',
    mobile_number_calling_code: '',
    mobile_number: '',
    alternative_mobile_number_calling_code: '',
    alternative_mobile_number: '',
    landline_calling_code: '',
    landline_number: '',
    address: '',
    city_id: null,
    province_id: null,
    postal_code: '',
    country_id: null,
    additional_notes: '',
    profile_photo: '',
    display_online: false,
    tag_list: []
}


// WEBPACK FOOTER //
// ./src/store/modules/genericContact/properties.js